import React from "react";
import styles from "./Authentication.module.scss";

export default function AuthenticationLoading() {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src="/process.svg" alt="Processing" className={styles.image} />
        <h1 className={styles.heading}>Authentication In Progress</h1>
        <p className={styles.subtext}>
          You will be redirected to your application
        </p>
      </div>
    </div>
  );
}
